import React, { useContext } from 'react';
import Select from '../../../../components/shared/InputElements/Select';
import UserPrefsContext from '../../../../context/UserPrefs/UserPrefsContext';
import { useIntl } from 'react-intl';

const SelectCurrentRate = ({ rates }) => {
  const intl = useIntl();
  const userPrefs = useContext(UserPrefsContext);

  return (
    <Select
      id="home-charging-advisor-current-rate-id"
      value={userPrefs.get('currentRateId')}
      handler={(e) => userPrefs.set({ currentRateId: e.target.value })}
      optionNames={rates.map((rate) => {
        if (rate.id === 'TOD')
          return intl.formatMessage({
            id: 'tod.title',
            defaultMessage: 'Time-of-Day (5-8 pm) Rate (TOD)',
            description: 'TOD',
          });
        return rate.title;
      })}
      optionValues={rates.map((rate) => rate.id)}
      label={intl.formatMessage({
        id: 'hcaCurrentElectricRate',
        defaultMessage: 'Current rate',
        description: 'Current rate',
      })}
    />
  );
};

export default SelectCurrentRate;
